import React, { useState } from "react";
import Loader from "../mini/Loader";
import Speciality from "../mini/Speciality";
import { useQuery } from "@tanstack/react-query";
import { getBlogTagsAPI } from "../../api/GetTags";
import * as H from "./Home.styled";

const PopularTags = () => {
  const [popularTags, setPopularTags] = useState([]);

  const { isLoading } = useQuery({
    queryKey: ["GetPopularTags"],
    queryFn: () =>
      getBlogTagsAPI({
        size: 4,
        page: 1,
        type: "speciality",
        category: "popular",
      }),
    select: ({ data }) => data.data.tags,
    onSuccess: (tags) => setPopularTags(tags),
  });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        popularTags.length > 0 && (
          <H.HomeSidebarWrapper>
            <H.HomeTitle>Popular Specialties</H.HomeTitle>
            <div className="flex flex-col gap-4">
              {popularTags.map((tag) => (
                <Speciality
                  key={tag.id}
                  tag={tag}
                  clickable={true}
                  isBlue={true}
                />
              ))}
            </div>
          </H.HomeSidebarWrapper>
        )
      )}
    </>
  );
};

export default PopularTags;
